import type { ComponentType } from "react";
import {
  Input,
  Form,
  Row,
  Col,
  Card,
  Select,
  Typography,
  DatePicker,
  TimePicker,
  Upload,
  Tree,
  Tabs,
  Steps,
  Badge,
  Avatar,
  Dropdown,
  Pagination,
  Switch,
  Radio,
  Checkbox,
  Cascader,
  InputNumber,
  Table,
  Descriptions,
  List,
  Spin,
  Alert,
  Progress,
  Skeleton,
  Tooltip,
  Popconfirm,
  Divider,
  Statistic,
  Timeline,
  Result,
} from "@mijadesign/web";

import { Layout } from "antd";
import ProTableWrapper from "./antdPro/ProTable/ProTableWrapper";
import SchemaFormWrapper from "./antdPro/SchemaForm/SchemaFormWrapper";
import FilterColumnsWrapper from "./antdPro/FilterColumns/FilterColumnsWrapper";
import DrawerWrapper from "./antd/Drawer/DrawerWrapper";
import ModalWrapper from "./antd/Modal/ModalWrapper";
import EmptyWrapper from "./antd/Empty/EmptyWrapper";
import ButtonWrapper from "./antd/Button/ButtonWrapper";
import SpaceWrapper from "./antd/Space/SpaceWrapper";
import TagWrapper from "./antd/Tag/TagWrapper";
import PopoverWrapper from "./antd/Popover/PopoverWrapper";
import BreadcrumbWrapper from "./antd/Breadcrumb/BreadcrumbWrapper";
import ListWrapper from "./antd/List/ListWrapper";
import DescriptionsWrapper from "./antd/Descriptions/DescriptionsWrapper";
import DesensitizationDisplay from "./custom/DesensitizationDisplay";
import ScenarioFlowBoard from "./custom/scenario/ScenarioFlowBoard";
import ScenarioFlowScene from "./custom/scenario/ScenarioFlowScene";
import ScenarioFlowStep from "./custom/scenario/ScenarioFlowStep";

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * 组件映射表: componentName → React 组件
 */
export const componentMap: Record<string, ComponentType<any>> = {
  // 通用组件
  Button: ButtonWrapper,
  Space: SpaceWrapper,
  DesensitizationDisplay,

  // 布局组件
  Layout,
  "Layout.Header": Layout.Header,
  "Layout.Sider": Layout.Sider,
  "Layout.Content": Layout.Content,
  "Layout.Footer": Layout.Footer,
  // 兼容简写名称
  Header: Layout.Header,
  Sider: Layout.Sider,
  Content: Layout.Content,
  Footer: Layout.Footer,
  Row,
  Col,
  Card,

  // 表单组件
  Input,
  "Input.TextArea": Input.TextArea,
  "Input.Search": Input.Search,
  "Input.Password": Input.Password,
  Form,
  "Form.Item": Form.Item,
  Select,
  InputNumber,

  // 日期时间组件
  DatePicker,
  "DatePicker.RangePicker": DatePicker.RangePicker,
  TimePicker,

  // 上传组件
  Upload,

  // 树形组件
  Tree,

  // 标签页组件
  Tabs,

  // 步骤条组件
  Steps,

  // 标签组件
  Tag: TagWrapper,
  ScenarioFlowBoard,
  ScenarioFlowScene,
  ScenarioFlowStep,

  // 徽标组件
  Badge,
  "Badge.Ribbon": Badge.Ribbon,

  // 头像组件
  Avatar,
  "Avatar.Group": Avatar.Group,

  // 下拉菜单组件
  Dropdown,
  "Dropdown.Button": Dropdown.Button,

  // 面包屑组件
  Breadcrumb: BreadcrumbWrapper,

  // 分页组件
  Pagination,

  // 开关组件
  Switch,

  // 单选组件
  Radio,
  "Radio.Group": Radio.Group,
  RadioButton: Radio.Button,

  // 复选组件
  Checkbox,
  "Checkbox.Group": Checkbox.Group,

  // 级联选择器
  Cascader,

  // 表格组件
  Table,

  // Typography 组件
  Typography: Typography,
  "Typography.Title": Typography.Title,
  "Typography.Paragraph": Typography.Paragraph,
  "Typography.Text": Typography.Text,

  // 数据展示
  ProTable: ProTableWrapper,

  // 表单增强
  SchemaForm: SchemaFormWrapper,
  FilterColumns: FilterColumnsWrapper,

  // 反馈组件
  Modal: ModalWrapper,
  Drawer: DrawerWrapper,

  // 其他常用组件
  Descriptions: DescriptionsWrapper,
  "Descriptions.Item": Descriptions.Item,
  List: ListWrapper,
  "List.Item": List.Item,
  Empty: EmptyWrapper,
  Spin,
  Alert,
  Progress,
  Skeleton,
  Tooltip,
  Popconfirm,
  Popover: PopoverWrapper,
  Divider,
  Statistic,
  Timeline,
  "Timeline.Item": Timeline.Item,
  Result,
};

/**
 * 获取组件
 */
export function getComponent(componentName: string): ComponentType<any> | null {
  const component = componentMap[componentName];
  if (!component) {
    console.warn(
      `[ComponentMap] 组件 "${componentName}" 未找到，可用组件:`,
      Object.keys(componentMap),
    );
  }
  return component || null;
}

/**
 * 注册自定义组件
 */
export function registerComponent(
  componentName: string,
  component: ComponentType<any>,
): void {
  componentMap[componentName] = component;
}
